var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.33203V2.26536C10.0002 2.63873 10.0002 2.82542 9.9275 2.96802C9.86359 3.09347 9.7616 3.19545 9.63616 3.25937C9.49355 3.33203 9.30686 3.33203 8.9335 3.33203H7.06683C6.69346 3.33203 6.50678 3.33203 6.36417 3.25937C6.23873 3.19545 6.13674 3.09347 6.07283 2.96802C6.00016 2.82542 6.00016 2.63873 6.00016 2.26536V1.33203M5.46683 14.6654H10.5335C11.2802 14.6654 11.6536 14.6654 11.9388 14.52C12.1897 14.3922 12.3937 14.1882 12.5215 13.9374C12.6668 13.6521 12.6668 13.2788 12.6668 12.532V3.46536C12.6668 2.71863 12.6668 2.34526 12.5215 2.06004C12.3937 1.80916 12.1897 1.60519 11.9388 1.47736C11.6536 1.33203 11.2802 1.33203 10.5335 1.33203H5.46683C4.72009 1.33203 4.34672 1.33203 4.06151 1.47736C3.81063 1.60519 3.60665 1.80916 3.47882 2.06004C3.3335 2.34526 3.3335 2.71863 3.3335 3.46536V12.532C3.3335 13.2788 3.3335 13.6521 3.47882 13.9374C3.60665 14.1882 3.81063 14.3922 4.06151 14.52C4.34672 14.6654 4.72009 14.6654 5.46683 14.6654Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d1a22f34059e6590f1c0447f007c9198.svg";
export { ForwardRef as ReactComponent };